export enum RestrictionSelectorType {
    Dropdown,
    Checkbox
}
